export const freeStarPlacementNameFinder = (
  placementName: string,
  sticky: boolean,
  index: number,
  path: string,
): string => {
  let trueIndex = index > 5 ? 5 : index - 1;
  if (trueIndex < 0) trueIndex = 0;
  switch (true) {
    case placementName.includes('InStream'):
      return `fortunecom_infeed${trueIndex}`;
    case placementName.includes('RightRailFlex') && sticky && path.includes('crypto'):
      return `fortunecom_crypto_siderail_sticky`;
    case placementName.includes('RightRailFlex') && sticky:
      return `fortunecom_siderail_sticky`;
    case placementName.includes('RightRail_Article') && sticky:
      return `fortunecom_siderail_article_sticky`;
    case placementName.includes('RightRailFlex'):
      return `fortunecom_siderail_flex_${index}`;
    case placementName === 'Leaderboard' && path.includes('videos'):
      return 'fortunecom_videos_leaderboard_top';
    case placementName === 'Leaderboard':
      return 'fortunecom_leaderboard_top';
    case placementName === 'StickyFooter' && sticky:
      return 'fortunecom_sticky_footer';
    default:
      return `fortunecom_incontent${trueIndex}`;
  }
};

export const publisher = 'fortune-com';
